module.exports = __webpack_public_path__ + "static/img/组 2846.c83bc71.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/auditing/images/组 2846.png
// module id = lByf
// module chunks = 0